<div class="container-fluid" *ngIf="permissions.canRead(permissions.ComponentID.TrainingConfig)">
  <div class="row top10">
    <div class="col-xs-12">
      <h3 class="page-header">{{headerText}}</h3>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <mat-label>Select Table: </mat-label>
      <mat-form-field appearance="fill" >
        <mat-select name="qualOwnerId"
            (selectionChange)="getSelectedTable($event)">
          <mat-option *ngFor="let t of tableDropDownItems" [value]="t.text"> {{ t.text }} </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- showQualsGrid -->
  <div class="row top20" *ngIf="showQualsGrid">
    <div class="col-xs-12">
      <aims-common-table
                    id="quals-table"
                    [dataSource]="quals | async"
                    [header]="qualsTableHeader"
                    [permissions]="qualsTablePermissions| async"
                    pageSize="10"
                    [addRowInitialObject]="defaultQual"
                    (rowAdded)="handleQualRowUpdate($event)"
                    (rowUpdated)="handleQualRowUpdate($event)"
                    [stickyHeader]="true">
          <aims-common-table-dynamic-row id="qualOwnerId">
            <ng-template viewMode let-element >
              {{ element.qualOwnerId | getText:'employeeId':'fullName':employeeValues }}
            </ng-template>

            <ng-template editMode let-element let-dynamicControl="dynamicControl">
              <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
                <mat-select style="width: 100px" [formControl]="dynamicControl" name="qualOwnerId">
                  <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>

            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
        <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" *ngIf="element.qualId != 0" style="width: 50%;">
              <aims-common-table
                    id="quals-task-table"
                    [dataSource]="element.trQualXQualTasks "
                    [header]="qualsQualTasksTableHeader"
                    [permissions]="qualQualTasksTablePermissions| async"
                    pageSize="5"
                    [addRowInitialObject]="defaultQualQualTask"
                    (rowUpdated)="handleQualQualTaskRowUpdate($event)"
                    (rowDeleted)="handleQualQualTaskRowDelete($event)"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewQualQualTaskPopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Link to a Qual Task
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="qualTaskId">
                  <ng-template viewMode let-element >
                    {{ element.qualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <aims-lookup name="QualToQualTaskLookup"
                                [formControl]="dynamicControl"
                                [(ngModel)]="element.qualTaskId"
                                [gridText]="'Select a Task to link to Qualification: ' + getQualDescription(element.qualId)"
                                id="QualToQualTaskLookup"
                                [values]="qualTaskPuValues | async"
                                [idPropertyName]="'qualTaskId'"
                                [displayPropertyName]="'qtDesc'"
                                [columnsInGrid]="qualificationTaskLookupColumns"
                                style="width:100%"
                                required>
                    </aims-lookup>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let q of qualTaskValues | async" [value]="q.qualTaskId"> {{ q.qtDesc }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>

            <div class="col-md-6" *ngIf="element.requiredByAllEmps == false && element.qualId != 0">
              <aims-common-table
                    id="req-quals-emp-table"
                    [dataSource]="element.trQualXAssigned "
                    [header]="reqQualForEmpTableHeader"
                    [permissions]="reqQualForEmpTablePermissions| async"
                    pageSize="5"
                    [addRowInitialObject]="defaultReqQualForEmp"
                    (rowUpdated)="handleReqQualForEmpRowUpdate($event)"
                    (rowDeleted)="handleReqQualForEmpRowDelete($event)"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewReqQualForEmpPopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Individually Assigned Link
                  </aims-common-button>
                  <aims-common-button aria-label="Add" (click)="addMultipleNewReqQualForEmpPopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Multiple Individually Assigned Links
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="qualId">
                  <ng-template viewMode let-element >
                    {{ element.qualId | getText:'qualId':'qualDesc':qualValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                     <aims-lookup name="QualtoIndividuallyAssignedLookup"
                                [formControl]="dynamicControl"
                                [gridText]="'Select Qualification ' + getQualDescription(element.qualId) + ' to individually assign!'"
                                id="QualtoIndividuallyAssignedLookup"
                                [values]="qualPuValues | async"
                                [idPropertyName]="'qualId'"
                                [displayPropertyName]="'qualDesc'"
                                [(ngModel)]="element.qualId"
                                [columnsInGrid]="qualificationLookupColumns"
                                style="width:100%"
                                required>
                    </aims-lookup>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="employeeId">
                  <ng-template viewMode let-element >
                    {{ element.employeeId | getText:'employeeId':'fullName':employeeValues }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
                      <mat-select style="width: 100px" [formControl]="dynamicControl" name="employeeId" >
                        <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>

              </aims-common-table>
            </div>
            <div class="col-md-6" *ngIf="element.requiredByAllEmps == false && element.qualId != 0">
              <aims-common-table
                    id="req-quals-job-table"
                    [dataSource]="element.trQualXJobTitles"
                    [header]="reqQualForJobTableHeader"
                    [permissions]="reqQualForJobTablePermissions| async"
                    pageSize="5"
                    [addRowInitialObject]="defaultReqQualForJob"
                    (rowUpdated)="handleReqQualForJobRowUpdate($event)"
                    (rowDeleted)="handleReqQualForJobRowDelete($event)"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewQualJobTitlePopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Link to a Job Title
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="jobTitleId">
                  <ng-template viewMode let-element >
                    {{ element.jobTitleId | getText:'jobTitleId':'jobTitle':jobTitleValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <aims-lookup name="ReqJobTitleLookup"
                                [formControl]="dynamicControl"
                                [gridText]="'Select a Job Title to link to Qualification: ' + getQualDescription(element.qualId)"
                                id="ReqJobTitleLookup"
                                [values]="jobTitlePuValues | async"
                                [idPropertyName]="'jobTitleId'"
                                [displayPropertyName]="'jobTitle'"
                                [(ngModel)]="element.jobTitleId"
                                [columnsInGrid]="jobTitleLookupColumns"
                                style="width:100%"
                                required>
                    </aims-lookup>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let j of jobTitleValues | async" [value]="j.jobTitleId"> {{ j.jobTitle }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
               </aims-common-table>
            </div>

            <div class="col-md-6" *ngIf="element.requiredByAllEmps == false && element.qualId != 0" >
              <aims-common-table
                    id="req-quals-job-assignment-table"
                    [dataSource]="element.trQualXJobAssignments"
                    [header]="reqQualForJobAssignmentTableHeader"
                    [permissions]="reqQualForJobAssignmentTablePermissions| async"
                    pageSize="5"
                    [addRowInitialObject]="defaultReqQualForJobAssignment"
                    (rowUpdated)="handleReqQualForJobAssignmentRowUpdate($event)"
                    (rowDeleted)="handleReqQualForJobAssignmentRowDelete($event)"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewQualJobAssignmentPopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Link to a Job Assignment
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="employeeJobAssignmentId">
                  <ng-template viewMode let-element >
                    {{ element.employeeJobAssignmentId | getText:'employeeJobAssignmentId':'desc':jobAssignmentPuValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <aims-lookup name="ReqJobAssignmentLookup"
                                [formControl]="dynamicControl"
                                 [gridText]="'Select a Job Assignment to link to Qualification: ' + getQualDescription(element.qualId)"
                                 id="ReqJobAssignmentLookup"
                                 [values]="jobAssignmentPuValues | async"
                                 [idPropertyName]="'employeeJobAssignmentId'"
                                 [displayPropertyName]="'desc'"
                                 [(ngModel)]="element.employeeJobAssignmentId"
                                 [columnsInGrid]="jobAssignmentLookupColumns"
                                 style="width:100%"
                                 required>
                    </aims-lookup>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let j of jobAssignmentPuValues | async" [value]="j.employeeJobAssignmentId"> {{ j.desc }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
               </aims-common-table>
            </div>
          </div>
        </ng-template>
      </aims-common-table>
    </div>
  </div>

  <!-- showQualTasksGrid -->
  <div class="row top20" *ngIf="showQualTasksGrid">
    <div class="col-xs-12">
      <aims-common-table
                    id="qual-tasks-table"
                    [dataSource]="qualTasks | async"
                    [header]="qualTasksTableHeader"
                    [permissions]="qualTasksTablePermissions| async"
                    pageSize="10"
                    [addRowInitialObject]="defaultQualTask"
                    (rowAdded)="handleQualTaskRowUpdate($event)"
                    (rowUpdated)="handleQualTaskRowUpdate($event)"
                    [stickyHeader]="true">

          <aims-common-table-dynamic-row id="qualTaskWsOwnerId">
            <ng-template viewMode let-element >
              {{ element.qualTaskWsOwnerId | getText:'workSectionId':'workSection':workSectionValues | async }}
            </ng-template>

            <ng-template editMode let-element let-dynamicControl="dynamicControl">
              <aims-lookup name="QualTaskWsOwnerLookup"
                        [formControl]="dynamicControl"
                        [gridText]="'Select a Work Section as the Owner of this Task'"
                        id="QualTaskWsOwnerLookup"
                        [values]="workSectionValues | async"
                        [idPropertyName]="'workSectionId'"
                        [displayPropertyName]="'workSection'"
                        [(ngModel)]="element.qualTaskWsOwnerId"
                        [columnsInGrid]="workSectionLookupColumns"
                        style="width:100%"
                        required>
              </aims-lookup>
            </ng-template>

            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let w of workSectionValues| async" [value]="w.workSectionId"> {{ w.workSection }} </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="goToQualTaskUrlLink">
            <ng-template viewMode let-element >
              <a *ngIf="element.qualTaskUrlLink != null && element.qualTaskUrlLink.length > 1" target="_blank" style="color:blue" href="{{element.qualTaskUrlLink}}">Go To</a>
            </ng-template>
          </aims-common-table-dynamic-row>

          <ng-template aimsCommonTableExpandedRow let-element >
            <div style="flex-wrap: wrap;  width:100%">
            <div class="col-md-4"  *ngIf="element.qualTaskId != 0" style="width: 50%;">
              <aims-common-table
                    id="task-quals-table"
                    [dataSource]="element.trQualXQualTasks"
                    [header]="qualTasksToQualTableHeader"
                    [permissions]="qualTasksToQualTablePermissions| async"
                    pageSize="5"
                    [addRowInitialObject]="defaultQualQualTask"
                    (rowUpdated)="handleQualQualTaskRowUpdate($event)"
                    (rowDeleted)="handleQualQualTaskRowDelete($event)"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewQualTaskQualPopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Link to a Qualification
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="qualId">
                  <ng-template viewMode let-element >
                    {{ element.qualId | getText:'qualId':'qualDesc':qualValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <aims-lookup name="QualificationLookup"
                                [formControl]="dynamicControl"
                                [gridText]="'Select a Qualification to link to Task: ' +  getQualTaskDescription(element.qualTaskId)"
                                id="QualificationLookup"
                                [values]="qualPuValues | async"
                                [idPropertyName]="'qualId'"
                                [displayPropertyName]="'qualDesc'"
                                [columnsInGrid]="qualificationLookupColumns"
                                style="width:100%"
                                required>
                    </aims-lookup>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let q of qualValues | async" [value]="q.qualId"> {{ q.qualDesc }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>

            <div class="col-md-4" *ngIf="element.qualTaskId != 0"  style="width: 50%;">
              <aims-common-table
                    id="task-2-prequitsite-task-table"
                    [dataSource]="element.trQualTaskXPrerequisitesQualTask"
                    [header]="qualTasksToPrequisiteQualTaskTableHeader"
                    [permissions]="qualTasksToPrequisiteQualTaskTablePermissions| async"
                    pageSize="5"
                    [addRowInitialObject]="defaultQualTaskPrerequisite"
                    (rowUpdated)="handleQualTaskPreqequisiteRowUpdate($event)"
                    (rowDeleted)="handleQualTaskPreqequisiteRowDelete($event)"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewQualTaskPrerequisitePopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Link to a Prerequisite Qual Task
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="preReqQualTaskId">
                  <ng-template viewMode let-element >
                    {{ element.preReqQualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                      <aims-lookup name="PreQualTaskLookup"
                                [formControl]="dynamicControl"
                                 [gridText]="'Select a Pre-Qualification Task for: ' + getQualTaskDescription(element.qualTaskId)"
                                 id="PreQualTaskLookup"
                                 [values]="qualTaskPuValues | async"
                                 [idPropertyName]="'qualTaskId'"
                                 [displayPropertyName]="'qtDesc'"
                                 [(ngModel)]="element.preReqQualTaskId"
                                 [columnsInGrid]="qualificationTaskLookupColumns"
                                 style="width:100%"
                                 required>
                    </aims-lookup>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let q of qualTaskValues | async" [value]="q.qualTaskValues"> {{ q.qtDesc }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>

            <div class="col-md-4" *ngIf="element.qualTaskId != 0"  style="width: 50%;">
              <aims-common-table
                    id="task-trainer-table"
                    [dataSource]="element.trQualTaskXTrainers"
                    [header]="qualTasksTrainerTableHeader"
                    [permissions]="qualTasksTrainerTablePermissions| async"
                    pageSize="5"
                    [addRowInitialObject]="defaultQualTaskTrainer"
                    (rowUpdated)="handleQualTaskTrainerRowUpdate($event)"
                    (rowDeleted)="handleQualTaskTrainerRowDelete($event)"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewQualTaskTrainerPopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Link to a Trainer
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="trainerId">
                  <ng-template viewMode let-element >
                    {{ element.trainerId | getText:'trainerId':'fullName':trainerValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                     <aims-lookup name="TrainerLookup"
                                id="TrainerLookup"
                                [formControl]="dynamicControl"
                                [gridText]="'Select an assigned trainer for: ' + getQualTaskDescription(element.qualTaskId)"
                                [values]="trainerPuValues | async"
                                [idPropertyName]="'trainerId'"
                                [displayPropertyName]="'fullName'"
                                [(ngModel)]="element.trainerId"
                                [columnsInGrid]="trainerLookupColumns"
                                style="width:100%"
                                required>
                    </aims-lookup>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let t of trainerValues | async" [value]="t.trainerId"> {{ t.fullName }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </ng-template> <!-- expanded -->
      </aims-common-table>
    </div>
  </div>

  <!-- showQualQualTasksGrid -->
  <div class="row top20" *ngIf="showQualQualTasksGrid">
    <div class="col-xs-12">
      <aims-common-table
                    id="qual-qual-tasks-table"
                    [dataSource]="qualQualTasks | async"
                    [header]="qualXQualTasksTableHeader"
                    [permissions]="qualXQualTasksTablePermissions| async"
                    pageSize="10"
                    [addRowInitialObject]="defaultQualQualTask"
                    (rowAdded)="handleQualXQualTaskRowUpdate($event)"
                    (rowUpdated)="handleQualXQualTaskRowUpdate($event)"
                    (rowDeleted)="handleQualXQualTaskRowDelete($event)"
                    [stickyHeader]="true">

        <aims-common-table-dynamic-row id="qualId">
          <ng-template viewMode let-element >
            {{ element.qualId | getText:'qualId':'qualDesc':qualValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
           <aims-lookup name="QualToQLookup"
                        [formControl]="dynamicControl"
                        id="QualToQLookup"
                        [gridText]="'Select a Qualification'"
                        [values]="qualPuValues | async"
                        [idPropertyName]="'qualId'"
                        [displayPropertyName]="'qualDesc'"
                        [(ngModel)]="element.qualId"
                        [columnsInGrid]="qualificationLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualValues| async" [value]="q.qualId"> {{ q.qualDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="qualTaskId">
          <ng-template viewMode let-element >
            {{ element.qualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
           <aims-lookup name="QualToQTLookup"
                        [formControl]="dynamicControl"
                        id="QualToQTLookup"
                        [gridText]="'Select a Task'"
                        [values]="qualTaskPuValues | async"
                        [idPropertyName]="'qualTaskId'"
                        [displayPropertyName]="'qtDesc'"
                        [(ngModel)]="element.qualTaskId"
                        [columnsInGrid]="qualificationTaskLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualTaskValues| async" [value]="q.qualTaskId"> {{ q.qtDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </div>
  </div>

  <!-- showQualTaskPrerequisitesGrid -->
  <div class="row top20" *ngIf="showQualTaskPrerequisitesGrid">
    <div class="col-xs-12">
      <aims-common-table
                    id="qual-tasks-prereq-table"
                    [dataSource]="qualTaskPrerequisites | async"
                    [header]="qualTasksXPrereqTableHeader"
                    [permissions]="qualTasksXPrereqTablePermissions| async"
                    pageSize="10"
                    [addRowInitialObject]="defaultQualTaskXPrereq"
                    (rowAdded)="handleQualTaskXPrereqRowUpdate($event)"
                    (rowUpdated)="handleQualTaskXPrereqRowUpdate($event)"
                    (rowDeleted)="handleQualTaskXPrereqRowDelete($event)"
                    [stickyHeader]="true">

        <aims-common-table-dynamic-row id="qualTaskId">
          <ng-template viewMode let-element >
            {{ element.qualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
          <aims-lookup name="PreQualToQTLookup"
                        [formControl]="dynamicControl"
                        id="PreQualToQTLookup"
                        [gridText]="'Select a Task'"
                        [values]="qualTaskPuValues | async"
                        [idPropertyName]="'qualTaskId'"
                        [displayPropertyName]="'qtDesc'"
                        [(ngModel)]="element.qualTaskId"
                        [columnsInGrid]="qualificationTaskLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualTaskValues| async" [value]="q.qualTaskId"> {{ q.qtDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="preReqQualTaskId">
          <ng-template viewMode let-element >
            {{ element.preReqQualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
            <aims-lookup name="PreQualToPreQTLookup"
                        [formControl]="dynamicControl"
                        id="PreQualToPreQTLookup"
                        [gridText]="'Select a Pre-Qualification Task'"
                        [values]="qualTaskPuValues | async"
                        [idPropertyName]="'qualTaskId'"
                        [displayPropertyName]="'qtDesc'"
                        [(ngModel)]="element.preReqQualTaskId"
                        [columnsInGrid]="qualificationTaskLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualTaskValues| async" [value]="q.qualTaskId"> {{ q.qtDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </div>
  </div>

  <!-- showIndAssignedGrid -->
  <div class="row top20" *ngIf="showIndAssignedGrid">
    <div class="col-xs-12">
      <aims-common-table
            id="quals-assigned-table"
            [dataSource]="reqQualsForEmps | async"
            [header]="qualXAssignedTableHeader"
            [permissions]="qualXAssignedTablePermissions| async"
            pageSize="10"
            [addRowInitialObject]="defaultQualXAssigned"
            (rowAdded)="handleQualXAssignedRowUpdate($event)"
            (rowUpdated)="handleQualXAssignedRowUpdate($event)"
            (rowDeleted)="handleQualXAssignedRowDelete($event)"
            [stickyHeader]="true">

        <aims-common-table-dynamic-row id="qualId">
          <ng-template viewMode let-element >
            {{ element.qualId | getText:'qualId':'qualDesc':qualValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
           <aims-lookup name="QualEmpReqLookup"
                        [formControl]="dynamicControl"
                        id="QualEmpReqLookup"
                        [values]="qualPuValues | async"
                        [gridText]="'Select a Qualification to assign to this Employee'"
                        [idPropertyName]="'qualId'"
                        [displayPropertyName]="'qualDesc'"
                        [(ngModel)]="element.qualId"
                        [columnsInGrid]="qualificationLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualValues| async" [value]="q.qualId"> {{ q.qualDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="employeeId">
          <ng-template viewMode let-element >
            {{ element.employeeId | getText:'employeeId':'fullName':employeeValues }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
            <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
              <mat-select style="width: 100px" [formControl]="dynamicControl" name="employeeId">
                <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </div>
  </div>

  <!-- showReqJobTitlesGrid -->
  <div class="row top20" *ngIf="showReqJobTitlesGrid">
    <div class="col-xs-12">
        <aims-common-table
            id="quals-job-title-table"
            [dataSource]="reqQualsForJobTitles | async"
            [header]="qualXJobTitleTableHeader"
            [permissions]="qualXJobTitleTablePermissions| async"
            pageSize="10"
            [addRowInitialObject]="defaultQualXJobTitles"
            (rowAdded)="handleQualXJobTitleRowUpdate($event)"
            (rowUpdated)="handleQualXJobTitleRowUpdate($event)"
            (rowDeleted)="handleQualXJobTitleRowDelete($event)"
            [stickyHeader]="true">

        <aims-common-table-dynamic-row id="qualId">
          <ng-template viewMode let-element >
            {{ element.qualId | getText:'qualId':'qualDesc':qualValuesNotReqByAll | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
           <aims-lookup name="QualToJTLookup"
                        [formControl]="dynamicControl"
                        id="QualToJTLookup"
                        [gridText]="'Select a Qualificaiton'"
                        [values]="qualPuValues | async"
                        [idPropertyName]="'qualId'"
                        [displayPropertyName]="'qualDesc'"
                        [(ngModel)]="element.qualId"
                        [columnsInGrid]="qualificationLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualValuesNotReqByAll| async" [value]="q.qualId"> {{ q.qualDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="jobTitleId">
          <ng-template viewMode let-element >
            {{ element.jobTitleId | getText:'jobTitleId':'jobTitle':jobTitlePuValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
              <aims-lookup style="width:100%"
                        [formControl]="dynamicControl"
                        name="QualToJobTitle"
                        id="QualToJobTitle"
                        [gridText]="'Select a Job Title'"
                        [values]="jobTitlePuValues | async"
                        [idPropertyName]="'jobTitleId'"
                        [displayPropertyName]="'jobTitle'"
                        [(ngModel)]="element.jobTitleId"
                        [columnsInGrid]="jobTitleLookupColumns">
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let j of jobTitleValues| async" [value]="j.jobTitleValues"> {{ j.jobTitle }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </div>
  </div>

  <!-- showReqJobAssignmentsGrid -->
  <div class="row top20" *ngIf="showReqJobAssignmentsGrid">
    <div class="col-xs-12">
      <aims-common-table
            id="quals-job-assignment-table"
            [dataSource]="reqQualsForJobAssignments | async"
            [header]="qualXJobAssignmentTableHeader"
            [permissions]="qualXJobAssignmentTablePermissions| async"
            pageSize="10"
            [addRowInitialObject]="defaultQualXJobAssignments"
            (rowAdded)="handleQualXJobAssignmentRowUpdate($event)"
            (rowUpdated)="handleQualXJobAssignmentRowUpdate($event)"
            (rowDeleted)="handleQualXJobAssignmentRowDelete($event)"
            [stickyHeader]="true">

        <aims-common-table-dynamic-row id="qualId">
          <ng-template viewMode let-element >
            {{ element.qualId | getText:'qualId':'qualDesc':qualValuesNotReqByAll | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
              <aims-lookup name="QualValuesNotReqByAllLookup"
                        [formControl]="dynamicControl"
                         id="QualValuesNotReqByAllLookup"
                         [values]="qualValuesNotReqByAll | async"
                         [gridText]="'Select a Qualification'"
                         [idPropertyName]="'qualId'"
                         [displayPropertyName]="'qualDesc'"
                         [(ngModel)]="element.qualId"
                         [columnsInGrid]="qualificationLookupColumns"
                         style="width:100%"
                         required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualValuesNotReqByAll| async" [value]="q.qualId"> {{ q.qualDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="employeeJobAssignmentId">
          <ng-template viewMode let-element >
            {{ element.employeeJobAssignmentId | getText:'employeeJobAssignmentId':'desc':jobAssignmentPuValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
             <aims-lookup name="JobAssignmentLookup"
                        [formControl]="dynamicControl"
                        id="JobAssignmentLookup"
                        [gridText]="'Select a Job Assignment'"
                        [values]="jobAssignmentPuValues | async"
                        [idPropertyName]="'employeeJobAssignmentId'"
                        [displayPropertyName]="'desc'"
                        [(ngModel)]="element.employeeJobAssignmentId"
                        [columnsInGrid]="jobAssignmentLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let j of jobAssignmentPuValues| async" [value]="j.jobAssignmentPuValues"> {{ j.desc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </div>
  </div>

  <!-- showTrainersGrid -->
  <div class="row top20" *ngIf="showTrainersGrid">
    <div class="col-xs-12">
      <aims-common-table
            id="trainers-table"
            [dataSource]="trainers | async"
            [header]="trainerTableHeader"
            [permissions]="trainerTablePermissions | async"
            pageSize="10"
            [addRowInitialObject]="defaultTrainer"
            (rowAdded)="handleTrainerRowUpdate($event)"
            (rowUpdated)="handleTrainerRowUpdate($event)"
            (rowDeleted)="handleTrainerRowDelete($event)"
            [stickyHeader]="true">

        <aims-common-table-dynamic-row id="employeeId">
          <ng-template viewMode let-element >
            {{ element.employeeId | getText:'employeeId':'fullName':employeeValues }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
           <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
              <mat-select style="width: 100px" [formControl]="dynamicControl" name="employeeId">
                <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let e of employeeValues" [value]="e.employeeId"> {{ e.fullName }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <ng-template aimsCommonTableExpandedRow let-element >
          <div style="flex-wrap: wrap; width:100%">
            <div class="col-md-6" *ngIf="element.qualId != 0" style="width: 100%;">

              <aims-common-table
                    id="quals-task-table"
                    [dataSource]="element.trQualTaskXTrainers "
                    [header]="trainerXQualTasksTableHeader"
                    [permissions]="trainerXQualTasksTablePermissions| async"
                    [addRowInitialObject]="defaultQualTaskXTrainers"
                    (rowUpdated)="handleTrainerXQualTaskRowUpdate($event)"
                    (rowDeleted)="handleTrainerXQualTaskRowDelete($event)"
                    pageSize="5"
                    [stickyHeader]="true">

                <ng-template aimsCommonTableDynamicToolbar>
                  <aims-common-button aria-label="Add" (click)="addNewTrainerQualTaskPopUp(element)" *ngIf="permissions.canCreate(permissions.ComponentID.TrainingConfig)">
                    <mat-icon>add</mat-icon>
                    Add Link to a Qual Task
                  </aims-common-button>
                </ng-template>

                <aims-common-table-dynamic-row id="qualTaskId">
                  <ng-template viewMode let-element >
                    {{ element.qualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}
                  </ng-template>

                  <ng-template editMode let-element let-dynamicControl="dynamicControl">
                    <aims-lookup name="TrainerQTLookup"
                                [formControl]="dynamicControl"
                                id="TrainerQTLookup"
                                [gridText]="'Select a Task to link to this Trainer'"
                                [values]="qualTaskPuValues | async"
                                [idPropertyName]="'qualTaskId'"
                                [displayPropertyName]="'qtDesc'"
                                [(ngModel)]="element.qualTaskId"
                                [columnsInGrid]="qualificationTaskLookupColumns"
                                style="width:100%"
                                required>
                    </aims-lookup>
                  </ng-template>

                  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                      <mat-label>Filter</mat-label>
                      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                        <mat-option label=""></mat-option>
                        <mat-option *ngFor="let q of qualTaskValues | async" [value]="q.qualTaskId"> {{ q.qtDesc }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </ng-template>
      </aims-common-table>
    </div>
  </div>

  <!--  showQualTaskTrainersGrid -->
  <div class="row top20" *ngIf="showQualTaskTrainersGrid">
    <div class="col-xs-12">
      <aims-common-table
            id="qual-task-trainers-table"
            [dataSource]="qualTaskTrainers | async"
            [header]="qualTaskXTrainerTableHeader"
            [permissions]="qualTaskXTrainerTablePermissions| async"
            pageSize="10"
            [addRowInitialObject]="defaultQualTaskXTrainers"
            (rowAdded)="handleTrainerXQualTaskRowUpdate($event)"
            (rowUpdated)="handleTrainerXQualTaskRowUpdate($event)"
            (rowDeleted)="handleTrainerXQualTaskRowDelete($event)"
            [stickyHeader]="true">
        <aims-common-table-dynamic-row id="qualTaskId">
          <ng-template viewMode let-element >
            {{ element.qualTaskId | getText:'qualTaskId':'qtDesc':qualTaskValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
             <aims-lookup name="QtTrainerLookup"
                        [formControl]="dynamicControl"
                        id="QtTrainerLookup"
                        [gridText]="'Select a Qualification Task to assign to a Trainer'"
                        [values]="qualTaskPuValues | async"
                        [idPropertyName]="'qualTaskId'"
                        [displayPropertyName]="'qtDesc'"
                        [(ngModel)]="element.qualTaskId"
                        [columnsInGrid]="qualificationTaskLookupColumns"
                        style="width:100%"
                        required>
            </aims-lookup>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let q of qualTaskValues | async" [value]="q.qualTaskId"> {{ q.qtDesc }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="trainerId">
          <ng-template viewMode let-element >
            {{ element.trainerId | getText:'trainerId':'fullName':trainerValues | async }}
          </ng-template>

          <ng-template editMode let-element let-dynamicControl="dynamicControl">
           <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
              <mat-select style="width: 100px" [formControl]="dynamicControl" name="employeeId">
                <mat-option *ngFor="let t of activeTrainerValues | async" [value]="t.trainerId"> {{ t.fullName }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>

          <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
            <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
              <mat-label>Filter</mat-label>
              <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                <mat-option label=""></mat-option>
                <mat-option *ngFor="let t of trainerValues | async" [value]="t.trainerId"> {{ t.fullName }} </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>
    </div>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
